import { render, staticRenderFns } from "./MainStudio.vue?vue&type=template&id=22c68bc0&scoped=true&"
import script from "./MainStudio.vue?vue&type=script&lang=js&"
export * from "./MainStudio.vue?vue&type=script&lang=js&"
import style0 from "./MainStudio.vue?vue&type=style&index=0&id=22c68bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c68bc0",
  null
  
)

export default component.exports